import { Box, Chip, Link, Paper, Typography } from '@mui/material';
import moment from 'moment';
import { NavLinkComponent } from '../../Router';
import { DataListComponent, NoDataPaper } from '../../components/data/DataTable';
import { ProvidedService } from '../../models/Types';
import { moneyFormat, periodNumToText } from '../../utils';
import { serviceStore, serviceTextRenderer } from '../project/service/ServiceCombo';

const styles = {
    mobileIconWrapper: {
        p: .66,
        display: 'flex',
        borderRadius: .5
    },
    mobileListItem: {
        display: 'flex',
        flexDirection: 'row!important',
        justifyContent: 'space-between',
        textDecoration: 'none',
        p: 2,
        gap: 2,
        alignItems: 'flex-start'
    }
}

export function buildProvidedServiceListItem(x: ProvidedService) {
    return <Paper component={NavLinkComponent} sx={styles.mobileListItem} elevation={2} route={[['id', x.Id]]}>
        <Box display="flex" flexDirection="column" minWidth={80} gap={.5}>
            <Link variant="h3" sx={{ textDecoration: 'none' }}>{serviceStore.data?.filter(s => s.Id == x.ServiceId).map(serviceTextRenderer)[0]}</Link>
            <Typography variant="subtitle2">{moment(x.CreateDate).format('DD.MM.yy')}</Typography>
        </Box>
        <Box>
            <Typography variant="h3">{moneyFormat(x.Sum)}</Typography>
        </Box>
    </Paper>;
}

export default class ProvidedServiceList extends DataListComponent<ProvidedService> {
    renderNoData() {
        return <NoDataPaper title="Отсутствуют оказанные услуги" content={['В этом разделе будут отображаться оказанные услуги']} />;
    }

    buildItemPaper(x: ProvidedService, i: number) {
        return buildProvidedServiceListItem(x);
    }
}